import React, { useRef, useEffect, useState, useContext } from "react";

import { Link } from 'react-router-dom';
import AuthService from "services/auth.service";
import { useNavigate } from "react-router-dom";

//import './styles.css'

//import '../App.css';
import logo from 'assets/logo.png';
//--- CONTEXT API -----------
import { useStore, useDispatch } from "store/StoreProvider";
import { types } from "store/StoreReducer";

const HeaderLteBasic =()=>{
  //---------------- CONTEXT API ------------------
  const store = useStore();
  const dispatch = useDispatch();

  const {user, products} = store;
  const navigate = useNavigate();

  //-----------------------------------
  const logout=(e)=>{
    e.preventDefault();
    console.log("logout");

    AuthService.logout();
    navigate("/login");
    //let history = useHistory();
    //history.push("/login");
    dispatch({type: types.authLogout})
  }
  return(
      <header className="main-header">

          {/*<!-- Logo -->*/}
          <a href="index2.html" className="logo">
              {/*<!-- mini logo for sidebar mini 50x50 pixels -->*/}
              <span className="logo-mini"><b>Edu</b>co</span>
              {/*<!-- logo for regular state and mobile devices -->*/}
              <span className="logo-lg"><b>Educo</b></span>
          </a>

          {/*<!-- Header Navbar: style can be found in header.less -->*/}
          <nav className="navbar navbar-static-top" style={{ padding: "0px" }}>
              {/*<!-- Sidebar toggle button-->*/}
              
              <div className="" style={{float: "left"}} >
                  <ul className="nav navbar-nav" style={{flexDirection: "row"}}>
                      {/*
                      <li  className="nav-item">
                          <Link to="/panel" className="buttonFlat " style={{color: "black"}}>
                          <i className="fa fa-home"></i> 
                          </Link>
                      </li>
                      */}
                      <li className="nav-item">
                          <span className="buttonFlat " style={{color: "black"}} >
                          <b>Rol:</b> {user?.rol_nom } |
                          <b>Periodo:</b> {user?.periodo }|
                          
                          </span>
                          

                      </li>
                      
                  </ul>            
              </div>
              {/*<!-- Navbar Right Menu -->*/}
              <div className="navbar-custom-menu" >
                  <ul className="nav navbar-nav" style={{ flexDirection: "row" }}>
                      {/*<!-- Messages: style can be found in dropdown.less-->*/}
                  
                      
                      {/*<!-- User Account: style can be found in dropdown.less -->*/}
                      <li className="nav-item dropdown has-arrow">
                        <a href="#" className="dropdown-toggle nav-link user-link"
                                    data-bs-toggle="dropdown">
                          <span className="user-img">
                            {user?.foto_path1.length > 0 &&
                              <img src={process.env.REACT_APP_AFILES + user.foto_path1}
                                className="rounded-circle"
                                alt="Usuario"
                                width="40" tag="" />

                            }
                            <span className="status online"></span>
                          </span>
                          <span>{user?.username}</span>
                        </a>
                        <div className="dropdown-menu">
                          
                          {/*<Link to="/cambiarclave" className="dropdown-item">
                            <i className="fa fa-key"></i> Cambiar clave
                          </Link>
                          */}
                          <button className="dropdown-item" onClick={logout} >Cerrar sesión</button>
                        </div>
                      </li>
                      {/*<!-- Control Sidebar Toggle Button -->*/}
                      
                  </ul>
              </div>

          </nav>
      </header>
  );
}

export default HeaderLteBasic;